import { render, staticRenderFns } from "./app-data-empty.vue?vue&type=template&id=c401851e&"
import script from "./app-data-empty.vue?vue&type=script&lang=js&"
export * from "./app-data-empty.vue?vue&type=script&lang=js&"
import style0 from "./app-data-empty.vue?vue&type=style&index=0&id=c401851e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports